import { useEffect } from 'react'
import { HeadFC, PageProps } from 'gatsby'
import queryString from 'query-string'

import Layout from '@src/components/Layout'
import Seo from '@src/components/Seo'
import AuthForm from '@src/components/AuthForm'
import { setLocalData } from '@models/LocalData'

import * as style from './style.module.sass'

const SignUpPage = ({ location }: PageProps) => {
  const { redirect } = queryString.parse(location.search)

  useEffect(() => {
    if (typeof redirect === 'string') {
      setLocalData('redirect', redirect)
    }
  }, [redirect])

  return (
    <Layout>
      <section className={style.signin}>
        <div className={style.formContainer}>
          <AuthForm type="signin" />
        </div>
      </section>
    </Layout>
  )
}

export const Head: HeadFC = ({ location }) => (
  <Seo pathName={location.pathname} title="Login" />
)

export default SignUpPage
